import type { PerioToothData } from '@/modules/claims/freeClaims/insuranceExport/types';

import type { MeasurementType, Side } from './types';

export const MeasurementRow = ({
  teeth,
  measurementType,
  side,
}: {
  teeth: PerioToothData[];
  measurementType: MeasurementType;
  side: Side;
}) => {
  return teeth.map((tooth, index) => (
    <div
      key={tooth.toothNumber}
      className={`vai-flex-1 vai-min-w-0 ${
        index < teeth.length - 1 ? 'vai-border-r vai-border-gray-400' : ''
      }`}
    >
      <div className="vai-flex">
        {(['distal', 'center', 'mesial'] as const).map((pos) => {
          const value = tooth[side][pos][measurementType];
          // In the perio chart, -1 is used to indicate that the value is not available
          const displayValue = value === '-1' ? '' : value;
          const isHighlighted =
            (measurementType === 'probingDepth' ||
              measurementType === 'clinicalAttachmentLevel') &&
            value &&
            Number.parseInt(value) >= 4;
          return (
            <div
              key={pos}
              className={`vai-flex-1 vai-text-center vai-text-xs vai-p-0.5 vai-min-w-0 ${
                isHighlighted
                  ? 'vai-bg-red-200 vai-text-red-800 vai-font-semibold'
                  : ''
              }`}
            >
              {displayValue}
            </div>
          );
        })}
      </div>
    </div>
  ));
};
